export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 导出按钮 */
    excelBtn: true,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 100,
    column: [
      {
        label: "ID",
        prop: "id",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "收款商户",
        prop: "payee",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        slot: true
      },
      {
        label: "退款编号",
        prop: "refundOrderNo",
        width: 190
      },
      {
        label: "订单编号",
        prop: "payOrderNo",
        slot: true,
        width: 190
      },
      {
        label: "支付方式",
        prop: "payMethod",
        slot: true
      },
      {
        label: "用户账号",
        prop: "username",
        slot: true,
        width: 140
      },
      {
        label: "申请时间",
        prop: "addTime",
        width: 160
      },
      {
        label: "申请人",
        prop: "addUser"
      },
      {
        label: "退款理由",
        prop: "refundReason"
      },
      {
        label: "申请金额",
        prop: "refundMoney"
      },
      {
        label: "退款状态",
        prop: "refundStatus",
        // 退款状态：1待处理 2退款中 3退款成功 4退款失败 5拒绝退款
        dicData: [
          {
            label: "待处理",
            value: 1
          },
          {
            label: "退款中",
            value: 2
          },
          {
            label: "退款成功",
            value: 3
          },
          {
            label: "退款失败",
            value: 4
          },
          {
            label: "拒绝退款",
            value: 5
          }
        ]
      },
      {
        label: "处理时间",
        prop: "reviewTime",
        width: 160
      },
      {
        label: "处理人",
        prop: "reviewUser"
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
};
